/// <reference lib="DOM"/>

import { Router } from "@solidjs/router";
import { render } from "solid-js/web";
import { App } from "./App";
import { AuthProvider } from "./components/AuthProvider";
import { RPCProvider } from "./components/RPCProvider";

const publicURL = new URL(window.location.origin);
const url = new URL(window.location.pathname, publicURL);
const rpcURL = new URL("/rpc", publicURL).href;
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCEL5hax8M7lOWfnbeiclOlxJHkdsjeqoM",
  authDomain: "one-sign-gr.firebaseapp.com",
};
render(
  () => (
    <Router url={url.pathname}>
      <AuthProvider config={firebaseConfig} publicURL={publicURL}>
        <RPCProvider baseURL={rpcURL}>
          <App />
        </RPCProvider>
      </AuthProvider>
    </Router>
  ),
  document.getElementById("root")!
);
